<template>
  <div class="content-wrapper">
    <app-page-top-section :title="$t('support_tickets')" icon="briefcase">
      <app-default-button btn-class="btn btn-success mr-2"
                          :title="$fieldTitle('create', 'ticket', true)"
                          @click="openModal()"
                          v-if="$can('create_crms') && !this.$isAdmin()"
      />
    </app-page-top-section>

    <app-table
        id="ticket-table"
        :options="options"
        :card-view="false"
        @reload="reloadTicketTable"
        @getRows="getSelectedRows"
        @action="triggerActions"
    />

    <app-support-ticket-create-edit-modal
        v-if="isModalActive"
        v-model="isModalActive"
        :selected-url="selectedUrl"
        @close="isModalActive = false"
    />

    <app-confirmation-modal
        v-if="confirmationModalActive"
        icon="trash-2"
        modal-id="app-confirmation-modal"
        @confirmed="confirmed('ticket-table')"
        @cancelled="cancelled"
    />


  </div>
</template>

<script>

import SupportTicketMixin from "../../Mixins/SupportTicketMixin";
import {GET_SUPPORT_TICKETS} from "../../../Config/ApiUrl";

export default {
  mixins: [SupportTicketMixin],
  data() {
    return {
      isModalActive: false,
      selectedUrl: '',
      tickets: [],
    };
  },
  async created() {
    // let response = await axios.get("/api/support-tickets");
    // this.tickets = response.data;
  },
  methods: {
    openModal() {
      this.isModalActive = true;
      this.selectedUrl = ''
    },
    triggerActions(row, action, active) {
      if (action.title === this.$t('edit')) {
        this.selectedUrl = `${GET_SUPPORT_TICKETS}/${row.id}`;
        this.isModalActive = true;
      }
      else {
        this.getAction(row, action, active)
      }

    },
  },
};
</script>
